import React, { useState } from 'react';
import { FaSearch, FaMagic } from 'react-icons/fa';

export default function SearchBar({ onSearch }) {
  const [query, setQuery] = useState('');
  const [isAIMode, setIsAIMode] = useState(false);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(query, isAIMode);
  };
  
  return (
    <div className="w-full max-w-2xl mx-auto px-4 py-3">
      <form onSubmit={handleSubmit} className="relative">
        <div className="flex items-center bg-white rounded-full shadow-md overflow-hidden border border-gray-200">
          <button 
            type="button"
            onClick={() => setIsAIMode(!isAIMode)}
            className={`px-3 py-2 ${isAIMode ? 'text-purple-600' : 'text-gray-500'}`}
            title={isAIMode ? "AI-powered discovery" : "Regular search"}
          >
            {isAIMode ? <FaMagic size={18} /> : <FaSearch size={18} />}
          </button>
          
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={isAIMode ? "Discover articles like..." : "Search articles..."}
            className="flex-1 py-2 px-2 outline-none"
          />
          
          <button 
            type="submit"
            className="bg-taupe hover:bg-taupe-dark text-white px-4 py-2 transition-colors"
          >
            {isAIMode ? 'Discover' : 'Search'}
          </button>
        </div>
      </form>
    </div>
  );
}